import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function ThreeInspectionFatigueDriving() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
